"use client";

import React from "react";
import { motion } from "framer-motion";
import { useAuth } from "@/hooks/useAuth";
import Link from "next/link";
import { useAppStore } from "@/store/useAppStore";

export const UserMobileImage = () => {
  const { user } = useAuth();
  const { setIsMenuOpen } = useAppStore();

  const getInitial = (email: string) => {
    return email ? email.charAt(0).toUpperCase() : "";
  };

  if (!user) {
    return null;
  }
  return (
    <Link href={"/my-account"} onClick={() => setIsMenuOpen(false)}>
      <motion.div
        className="flex w-14 h-14 rounded-full items-center justify-center text-sm font-bold backdrop-blur-sm border-2 cursor-pointer"
        style={{
          background: "linear-gradient(45deg, #a8edea 0%, #fed6e3 100%)",
          color: "#2d1b69",
          boxShadow: "0 4px 20px rgba(168, 237, 234, 0.4)",
          border: "2px solid rgba(168, 237, 234, 0.5)",
        }}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        whileHover={{
          scale: 1.1,
          boxShadow: "0 8px 30px rgba(168, 237, 234, 0.6)",
        }}
      >
        {getInitial(user.email)}
      </motion.div>
    </Link>
  );
};
